import { render, staticRenderFns } from "./AttendanceDesk.vue?vue&type=template&id=2a86ced6"
import script from "./AttendanceDesk.vue?vue&type=script&lang=js"
export * from "./AttendanceDesk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports